<template>
  <div class="d-flex flex-column justify-content-center align-items-center h-100 bg-light">
    <div class="row w-100">
      <div class="col col-sm-12 col-md-4 offset-md-4">
        <div class="col text-center text-cursive text-30 pb-2">
          WorkshopVue
        </div>
        <div class="card">
          <div class="card-body">
            <form>
              <div class="form-group">
                <label for="name">Nome</label>
                <input
                  type="text"
                  id="name"
                  class="form-control"
                  placeholder="Seu nome"
                  v-model.trim="name"
                >
              </div>
              <div class="form-group">
                <label for="email">Endereço de email</label>
                <input
                  type="email"
                  id="email"
                  class="form-control"
                  placeholder="Seu email"
                  v-model.trim="email"
                >
              </div>
              <div class="form-group">
                <label for="password">Senha</label>
                <input
                  type="password"
                  id="password"
                  class="form-control"
                  placeholder="Senha"
                  v-model.trim="password"
                >
              </div>
              <div class="form-group">
                <label for="password-confirm">Confirmação de Senha</label>
                <input
                  type="password"
                  class="form-control"
                  id="password-confirm"
                  placeholder="Confirmação de senha"
                  v-model.trim="passwordConfirm"
                  @keyup.enter="register"
                >
              </div>
              <button
                type="button"
                class="btn btn-orange btn-block"
                :disabled="isLoading"
                @click="register"
              >Cadastrar</button>
            </form>
          </div>
        </div>
        <div class="m-2 alert alert-danger" v-if="errors.length">
          <div v-for="(error, index) in errors" :key="`error-${index}`"> * {{error}} </div>
        </div>
        <div class="mt-2 text-center">
          Já possui uma conta? <router-link to="/login">Faça login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register',
  // Definição das variáveis que utilizaremos para controlar nosso formulário de registro
  data () {
    return {
      name: '',
      email: '',
      password: '',
      passwordConfirm: '',
      errors: [],
      isLoading: false,
      usersRef: window.firebase.firestore().collection('users')
    }
  },
  methods: {
    register () {
      this.errors = []
      if (this.isLoading || !this.isFormValid()) return
      this.isLoading = true
      window.firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
        .then(({ user }) => {
          user
            .updateProfile({
              displayName: this.name
            })
            .then(() => {
              this.saveUserIntoFirestore(user)
                .then(() => {
                  this.$store.dispatch('setCurrentUser', user)
                  this.$router.push('/')
                })
            })
            .catch(error => {
              this.errors.push(error.message)
            })
            .finally(() => (this.isLoading = false))
        })
        .catch(error => {
          this.errors.push(error.message)
        })
        .finally(() => (this.isLoading = false))
    },
    saveUserIntoFirestore (user) {
      return this.usersRef.doc(user.uid).set({
        id: user.uid,
        email: user.email,
        name: user.displayName
      })
    },
    isFormValid () {
      const hasEmptyFields = ['name', 'email', 'password', 'passwordConfirm'].some(field => this[field].length === 0)
      if (hasEmptyFields) {
        this.errors.push('Todos os campos são obrigatórios')
        return false
      }

      if (this.password !== this.passwordConfirm) {
        this.errors.push('Senha e confirmação são diferentes')
        return false
      }

      return true
    }
  }
}
</script>
